import React from 'react'
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Slider_group = {
    dots: true,
    nav:true,
    infinite: true,
    speed: 500,
    lazyLoad: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                initialSlide: 0
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};
const Slider_Unit = {
    dots: true,
    nav:true,
    infinite: true,
    lazyLoad: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                initialSlide: 0
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};
const AlobhaGroup = () => {
    const JavascriptVoid = (event) => {
		event.preventDefault();
	};
    const groupobj = [
        {
            id:1,
            img:"assets/img/alobha-units/Alobha-Logo-.webp",
        },
        {
            id:2,
            img:"assets/img/alobha-units/slg.webp",
        },
        {
            id:3,
            img:"assets/img/alobha-units/golde.webp",
        },
        {
            id:4,
            img:"assets/img/alobha-units/bubunu.webp",
        },
    ]
    const groupunitobj = [
        {
            id:1,
            img:"assets/img/alobha-units/infra.webp",
        },
        {
            id:2,
            img:"assets/img/alobha-units/navi.webp",
        },
        {
            id:3,
            img:"assets/img/alobha-units/asha.webp",
        },
        {
            id:4,
            img:"assets/img/alobha-units/school.webp",
        },
        {
            id:5,
            img:"assets/img/alobha-units/publicity.webp",
        },
    ]
    return (
        <>
            <section className="ptb-80 partners pb-4">
                <div className="container">
                    <div className="section-title">
                        <h2>Alobha Group</h2>
                        <div className="bar"></div>
                    </div>
                    <div className="slider " >
                        <Slider {...Slider_group}>
                            {groupobj.map((grpcard)=>{
                                return <div className="unit-items" key={grpcard.id}>
                                <div className="unit-box">
                                    <Link to="/" onClick={JavascriptVoid}>
                                        <img src={grpcard.img} alt="Project Screens" loading="lazy"/>
                                    </Link>
                                </div>
                            </div>
                            })}
                        </Slider>
                    </div>
                </div>
            </section>

            <section className="ptb-80 partners pb-4">
                <div className="container">
                    <div className="section-title">
                        <h2>A Unit Of Alobha Technologies Pvt Ltd.</h2>
                        <div className="bar"></div>
                    </div>
                    <div className="slider">
                        <Slider {...Slider_Unit}>
                            {groupunitobj.map((grpuntcard)=>{
                                return <div className="unit-items" key={grpuntcard.id}>
                                <div className="unit-box">
                                    <Link to="/" onClick={JavascriptVoid}>
                                        <img src={grpuntcard.img} alt="Project Screens" loading="lazy"/>
                                    </Link>
                                </div>
                            </div>
                            })}

                        </Slider>
                    </div>
                </div>
            </section>

        </>
    )
}

export default AlobhaGroup